export type {
  Color,
  EmployeeCreateRequest,
} from "@calendall/shared";

export type {
  SubscriptionCreateRequest,
  TenantCreateRequest,
} from "@calendall/shared";

export type {
  TenantFeatureConfig as TenantFeatureConfigCreate,
} from "@calendall/shared";

export type {
  Quotas,
  TenantQuota,
} from "@calendall/shared";

import type {AvailabilityRules} from "../util/default-availability";
import type {Color, Quotas, TenantFeatureConfig} from "@calendall/shared";

export type {AvailabilityRules};

// ── Runtime helpers ──────────────────────────────────────────────────────────

const DEFAULT_COLORS: Color[] = [
  {color: "blue", primary: "#64B5F6", secondary: "#BBDEFB", variants: []},
  {color: "green", primary: "#81C784", secondary: "#C8E6C9", variants: []},
  {color: "orange", primary: "#FFB74D", secondary: "#FFE0B2", variants: []},
  {color: "purple", primary: "#BA68C8", secondary: "#E1BEE7", variants: []},
];

export function defaultColor(): Color {
  return DEFAULT_COLORS[Math.floor(Math.random() * DEFAULT_COLORS.length)];
}

export function defaultQuotas(): Quotas {
  return {
    sms: {max: 0, used: 0},
    storageBytes: {max: 0, used: 0},
    email: {max: 0, used: 0},
  };
}

export function defaultFeatureConfig(): TenantFeatureConfig {
  return {
    smsSending: null,
    onlineBooking: null,
    themePicker: null,
    fileUpload: null,
    precalculatedAvailabilities: null,
    firstLaunch: null,
    shiftSchedule: null,
    smartBooking: null,
    resourceManagement: null,
    supportAssistant: null,
    stripePayments: null,
    bulkSms: null,
    subscriptionTesting: null,
    appointmentsV2: null,
    smsProvider: "AWS_SNS",
  };
}
